import { render, staticRenderFns } from "./toMeProblem.vue?vue&type=template&id=5282e392&scoped=true&"
import script from "./toMeProblem.vue?vue&type=script&lang=js&"
export * from "./toMeProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282e392",
  null
  
)

export default component.exports